import { useState, useEffect } from 'react';
import config from '../config';

import { Link } from 'react-router-dom';
import { Loader2, Star, MapPin, Briefcase } from 'lucide-react';

export const InstallersPage = () => {
  const [installers, setInstallers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchInstallers();
  }, []);

  const fetchInstallers = async () => {
    try {
      // آدرس درست برای دریافت نصاب‌های تأیید شده
      const response = await fetch(config.getApiUrl('/accounts/installers/'));
      
      if (response.ok) {
        const data = await response.json();
        console.log('Installers loaded:', data);
        // داده می‌تواند آرایه یا {results: []} باشد
        const installersList = Array.isArray(data) ? data : (data.results || []);
        setInstallers(installersList);
      } else {
        setError('خطا در دریافت لیست نصاب‌ها');
      }
    } catch (error) {
      console.error('Error fetching installers:', error);
      setError('خطا در ارتباط با سرور');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center text-red-600">
          <p>{error}</p>
          <button onClick={() => window.location.reload()} className="mt-4 bg-blue-600 text-white px-4 py-2 rounded">
            تلاش مجدد
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">نصابان حرفه‌ای</h1>
        <p className="text-gray-600 mb-8">بهترین نصاب‌های سیستم خورشیدی در ایران</p>
        
        {installers.length === 0 ? (
          <div className="bg-white rounded-xl p-12 text-center">
            <Briefcase className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 text-lg">هیچ نصاب تأیید شده‌ای یافت نشد</p>
            <p className="text-sm text-gray-400 mt-2">به زودی نصاب‌ها به لیست اضافه می‌شوند</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {installers.map((installer) => (
              <Link key={installer.id} to={`/installers/${installer.user.id}`} className="block">
                <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                      <Briefcase className="w-8 h-8 text-blue-600" />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-bold text-lg text-gray-900">{installer.company_name}</h3>
                      <div className="flex items-center gap-2 mt-1">
                        <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                        <span className="text-sm text-gray-600">{installer.rating || 'جدید'}</span>
                        <span className="text-gray-300">|</span>
                        <div className="flex items-center gap-1">
                          <MapPin className="w-3 h-3 text-gray-400" />
                          <span className="text-xs text-gray-500">
                            {installer.service_areas?.length > 0 ? installer.service_areas[0] : 'سراسر کشور'}
                          </span>
                        </div>
                      </div>
                      <p className="text-sm text-gray-600 mt-2 line-clamp-2">
                        {installer.bio?.substring(0, 100) || 'توضیحاتی ثبت نشده است'}
                      </p>
                      <div className="mt-3 flex justify-between items-center">
                        <span className="text-xs text-gray-400">{installer.experience_years || 0}+ سال تجربه</span>
                        <span className="text-blue-600 text-sm">مشاهده پروفایل →</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};